import React, { useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import WaitingAreaDuringCallsContent from '../components/pages/waiting-area/during-calls/content';
import { getCallQualityProfiles } from '../actions/portalSetting';

function WaitingAreaDuringCallsPage(props) {
  const showDuringCallsModal = useSelector((state) => state.modalReducer.showDuringCallsModal);
  const duringCallsForm = useSelector((state) => state.waitingAreaReducer.duringCallsForm);
  const isRecordingAvailableOnPortal = useSelector((state) => state.waitingAreaReducer.isRecordingAvailableOnPortal);
  const callQualityOptions =
    useSelector((state) => state.portalSettingReducer.videoQualityProfile.callQualityOptions) || [];
  const isWaitingAreaBulletinEnabled = useSelector(
    (state) => state.usersReducer.userProfile.isWaitingAreaBulletinEnabled
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (callQualityOptions === null || callQualityOptions.length == 0) {
      dispatch(getCallQualityProfiles());
    }
  }, []);

  return (
    <div>
      <WaitingAreaDuringCallsContent
        duringCallsForm={duringCallsForm}
        waitingArea={props.waitingArea}
        showDuringCallsModal={showDuringCallsModal}
        isRecordingAvailableOnPortal={isRecordingAvailableOnPortal}
        callQualityOptions={callQualityOptions}
        isWaitingAreaBulletinEnabled={isWaitingAreaBulletinEnabled}
        dispatch={dispatch}
        updateOrView={props.updateOrView}
      />
    </div>
  );
}

export default WaitingAreaDuringCallsPage;
